// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2_Dd0","subheader":"ReorderModal_subheader__1eqdX","listWrap":"ReorderModal_listWrap__2a8IG"};